import { useEffect, useState } from 'react';

const GPT_SRC = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';

let loadingPromise: Promise<void> | null = null;
let servicesEnabled = false;

export function useGpt(options?: { enabled?: boolean }) {
	const enabled = options?.enabled ?? true;
	const [ready, setReady] = useState(false);

	useEffect(() => {
		if (!enabled) return;

		if (window.googletag?.apiReady) {
			setReady(true);
			return;
		}

		if (loadingPromise) {
			loadingPromise.then(() => {
				setReady(true);
			});
			return;
		}

		loadingPromise = new Promise<void>(resolve => {
			window.googletag = window.googletag || { cmd: [] };

			const script = document.createElement('script');
			script.src = GPT_SRC;
			script.async = true;

			script.onload = () => {
				window.googletag.cmd.push(() => {
					if (!servicesEnabled) {
						window.googletag.pubads().enableSingleRequest();
						window.googletag.enableServices();
						servicesEnabled = true;
					}
					resolve();
				});
			};

			document.head.appendChild(script);
		});

		loadingPromise.then(() => {
			setReady(true);
		});
	}, [enabled]);

	return ready;
}
